export default {
    cashPayPlatform: {
        method: 'POST',
        url: '/manage-system/counter/page',
        name: '分页获取收银台'
    },
    getPlatform: {
        method: "POST",
        url: "/manage-system/counter/list",
        name: '获取收银台'
    },
    counterFreeze: {
        method: 'PUT',
        url: '/manage-system/counter/freeze/{id}',
        name: '冻结票台'
    },
    counterUnfreeze: {
        method: 'PUT',
        url: '/manage-system/counter/unfreeze/{id}',
        name: '解冻票台'
    },
    addCounter: {
        method: 'POST',
        url: '/manage-system/counter',
        name: '新增收银台'
    },
    updateCounter: {
        method: 'PUT',
        url: '/manage-system/counter',
        name: '修改收银台'
    },
    sellInfoCashier: {
        method: 'POST',
        url: '/manage-system/counter/ticket/page',
        name: '查询该票台的票券'
    },
    ticketShelveState: {
        method: 'PUT',
        url: '/manage-system/counter/ticket/toggleShow',
        name: '票券展示切换'
    }, 
    goodsShelveState: {
        method: 'PUT',
        url: '/storage-command/counter/isShow',
        name: '是否展示至该票台'
    },
    cardInfoList: {
        method: 'POST',
        url: '/manage-system/counter/balance/page',
        name: '储值卡信息分页'
    },
    cardInfoChange: {
        method: 'PUT',
        url: '/manage-system/counter/balance/toggleShow/{id}',
        name: '储值卡展示切换'
    },
    cashPayPlatformInfo: {
        method: 'GET',
        url: '/manage-system/counter/{id}',
        name: '收银台详情'
    },
    getWarehouseList: {
        method: 'GET',
        url: '/storage-command/counter/warehouse',
        name: '新增收银台-仓库列表'
    },
    addCounterStorageIndex: {
        method: 'POST',
        url: '/storage-command/counter/addCounterGoods',
        name: '新增票台仓库对应信息'
    },
    counterGoodsPage: {
        method: 'POST',
        url: '/storage-command/counter/goods/page',
        name: '获取零售信息列表'
    },
    retailInfoDetail: {
        method: 'GET',
        url: '/storage-command/counter/get',
        name: '零售信息详情'
    }
}